<div class="container">
  <div class="row">
    <form [formGroup]="logForm" class="dialog-form">
      <div class="row">
        <div class="col-md-3 col-sm-6 col-xs-12">
          <mat-form-field class="full-width">
            <mat-label>Date</mat-label>
            <input matInput formControlName="creationDateString" required />
            @if (logForm.get("creationDateString")?.hasError("required")) {
              <mat-error> Date is required. </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-md-3 col-sm-6 col-xs-12">
          <mat-form-field class="full-width">
            <mat-label>Name</mat-label>
            <input matInput formControlName="name" />
          </mat-form-field>
        </div>
        <div class="col-md-3 col-sm-6 col-xs-12">
          <mat-form-field class="full-width">
            <mat-label>Comment</mat-label>
            <input matInput formControlName="comment" />
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col d-flex justify-content-end align-self-end m-3">
          <button
            class="btn text-white bg-success"
            mat-raised-button
            (click)="saveLogDetails()"
          >
            Save <mat-icon>save</mat-icon>
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
